import * as mainTerms from '../mainTerms';

const inventory = mainTerms.Setting.inventory.default;

export const select = {
    status: '모든 상태',
    app: '모든 앱',
    inventory: '모든 ' + inventory,
    noData: '가능한 데이터가 없습니다.',
}